import gql from "graphql-tag";

export const getEntityCommonData = gql`
  query getEntityCommonData {
    getOptimizedComposite {
      e_id
      e_spk
      e_sn
      e_ln
    }
  }
`;

export const getMarketCommonData = gql`
  query getMarketCommonData {
    getOptimizedComposite {
      e_id
      e_typ
      e_egic
      e_geo
      r_sp
      r_md
      r_fch
    }
  }
`;

export const getCrmEntityCommonData = gql`
  query getCrmEntityCommonData {
    getCrmStatus(query: { in: [{ col: "crm_type", vals: ["entity"] }] }) {
      crm_type_id
      status
      assigned_to
      third_parties
    }
  }
`;

export const getPropertyCommonData = gql`
  query getPropertyCommonData {
    getProperty {
      id
      name
      type
      subtype
      geo_code
      psa_code
      address_raw
      latitude
      longitude
      buildings
      square_feet
      land_acres
      parking_spaces
      office_fraction
      construction_year
      tags
    }
  }
`;

// The server preserves the legacy FX formulas and exact-date inner joins.
// Keep these selections aligned with the former portfolio lookup columns.
export const getPurchaseFinancialContext = gql`
  query getPurchaseFinancialContext {
    getPurchaseFinancialContext {
      id
      property_id
      oak_entity_code
      oak_tranche_code
      status
      date
      currency
      tags
      price_usd
      noi_usd
    }
  }
`;

export const getSaleFinancialContext = gql`
  query getSaleFinancialContext {
    getSaleFinancialContext {
      id
      purchase_id
      property_id
      oak_entity_code
      oak_tranche_code
      status
      date
      currency
      gross_irr
      net_irr
      gross_moic
      net_moic
      tags
      price_usd
      noi_last_usd
    }
  }
`;

export const getFundingFinancialContext = gql`
  query getFundingFinancialContext {
    getFundingFinancialContext {
      id
      purchase_id
      property_id
      oak_entity_code
      oak_tranche_code
      equity_initial_fund_usd
      currency
      start_date
      io_expiry_date
      maturity_date
      benchmark
      loan_spread
      swap_mid
      credit_spread
      tags
      initial_amount_usd
      last_amount_usd
    }
  }
`;

export const getLeaseCommonData = gql`
  query getLeaseCommonData {
    getLease {
      id
      purchase_id
      property_id
      oak_entity_code
      tenant_raw
      guarantor_raw
      industry_raw
      initial_credit_rating
      start_date_orig
      end_date
      tags
    }
  }
`;

export const getDueDiligenceCommonData = gql`
  query getDueDiligenceCommonData {
    getDueDiligence {
      id
      purchase_id
      property_id
      oak_entity_code
      tags
    }
  }
`;

// Current raw DealCloud exposure owns picker membership, including unresolved
// holdings. BlueOwlPropertyID supplies the task ID, never the DealCloud EntryId.
export const getTenantTaskPropertyExposure = gql`
  query getTenantTaskPropertyExposure {
    getCurrentPurchaseExposure {
      property_asset_mgmt_id
      property_name
    }
  }
`;
